import { render, staticRenderFns } from "./translateBlock.vue?vue&type=template&id=7ebb0678&"
import script from "./translateBlock.vue?vue&type=script&lang=js&"
export * from "./translateBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports